import { render } from "./AuthorsTable.vue?vue&type=template&id=457e77ec"
import script from "./AuthorsTable.vue?vue&type=script&lang=js"
export * from "./AuthorsTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__